import React, { useState } from "react";
import "../styles/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Your message has been sent! We'll get back to you soon.");
  };

  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p>We're here to help! Reach out with any queries.</p>

      <div className="contact-details">
        <p>📍 Address: 123, Tech Park, Bangalore, India</p>
        <p>📞 Phone: +91 98765 43210</p>
        <p>📧 Email: support@hirepro.com</p>
      </div>

      <form onSubmit={handleSubmit}>
        <input type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
        <input type="email" name="email" placeholder="Your Email" required onChange={handleChange} />
        <textarea name="message" placeholder="Your Message" required onChange={handleChange}></textarea>
        <button type="submit">Send Message</button>
      </form>
    </div>
  );
};

export default Contact;
